/* unplugin-vue-components disabled */import { render } from "./Index.vue?vue&type=template&id=64a110be"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=64a110be&lang=css"

import exportComponent from "/myfunnl/isspadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__